import { useFilterFieldsContext } from '../../context'
import evaluateFieldDependency from '../../shared/evaluateFieldDependency/evaluateFieldDependency'
import Field from '../Field/Field'
import { FieldContextProvider } from '../Field/FieldContext'
import type { FieldContextValue } from '../Field/FieldContext.types'
import {
  useSectionFilteraction,
  useSectionGroupActions,
  useSectionNavigation
} from '../Section/SectionContext'
import FieldsView from './FieldsView'

const Fields = () => {
  const { config, form } = useFilterFieldsContext()
  const { groupedFieldValues, initialGroupedFieldValues } = form
  const navigation = useSectionNavigation()
  const { handleChangeFieldValues } = useSectionGroupActions()
  const { changedKeysData } = useSectionFilteraction()

  const {
    sectionLayout,
    currentFields: fields,
    fieldValues: rawFieldValues,
    groupPosition
  } = navigation

  const initialFieldValues = initialGroupedFieldValues[1]
  const fieldValues = rawFieldValues ?? initialFieldValues
  const interdependentFilteringConfig =
    config.filterAreaLayout?.interdependent_filtering

  const {
    uuidCurrentSitemodelObjectclass,
    fieldSettings,
    concatFields,
    selectAndLinkTargetPath
  } = config

  const fieldElements = fields.map((field) => {
    if (!field.uuid) return null

    const fieldName = field?.name || ''

    const {
      disabled,
      interdependentFilteringQuery,
      dependant,
      dependantFieldName
    } = evaluateFieldDependency({
      fieldName,
      fieldValues,
      interdependentFilteringConfig
    })

    const handleChangeAndClearDependant = (value: typeof fieldValues) => {
      if (!dependantFieldName || !dependant?.value.length) {
        handleChangeFieldValues(value)
        return
      }
      handleChangeFieldValues({
        ...value,
        [dependantFieldName]: {
          ...dependant,
          value: Array.isArray(dependant.value) ? [] : ''
        }
      })
    }

    const dateFormat = fieldSettings?.[fieldName]?.date_format || 'date-time'

    const fieldConcatenation = concatFields?.[fieldName]

    const changedFilteractionData = fieldName
      ? changedKeysData?.[groupPosition]?.[fieldName]
      : undefined
    const enableQRCodeReader = fieldSettings?.[fieldName]?.enable_qr_code_reader

    const fieldLayout = sectionLayout?.filter_fields.find(
      (fieldLayoutItem) => fieldLayoutItem.field_uuid === field.uuid
    )

    const fieldContextValue: FieldContextValue = {
      filterField: field,
      fieldLayout,
      fieldValues,
      handleChange: handleChangeAndClearDependant,
      uuidCurrentSitemodelObjectclass,
      groupedFieldValues,
      interdependentFilteringQuery,
      disabled,
      dateFormat,
      groupPosition,
      fieldConcatenation,
      selectAndLinkTargetPath,
      changedFilteractionData,
      enableQRCodeReader
    }

    return (
      <FieldContextProvider key={field.uuid} value={fieldContextValue}>
        <Field />
      </FieldContextProvider>
    )
  })

  return <FieldsView>{fieldElements}</FieldsView>
}

export default Fields
